import Style from "ol/style/Style";
import RegularShape from "ol/style/RegularShape";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Text from "ol/style/Text";
import {DefaultMaskWMS, DefaultPlotInfo  ,  TethysAPIAppName} from "../config";
import {Action} from "../store/actionType";
import {getURLParameters} from './helpers';

function formatDateToUTC(date) {
    const options = { year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
}
var myApp = {};
// First need to initilize
var filterCoodrdinate = {};

var endDate = new Date();
myApp.endDate = new Date(endDate.getTime() - (1 * 24 * 60 * 60 * 1000))



const ed = formatDateToUTC(myApp.endDate);


var startDate = new Date();
myApp.startDate = new Date(startDate.getTime() - (8 * 24 * 60 * 60 * 1000));


myApp.gk2a_endDate = endDate;

const sd = formatDateToUTC(myApp.startDate);


let archiveDate = getURLParameters()['date'];
if (archiveDate) {
    if (archiveDate.length == 8) {
        let checkInt = parseInt(archiveDate);
        if (checkInt) {
            // Number with valid
            let YYYY = parseInt(archiveDate.slice(0, 4));
            let MM_index = parseInt(archiveDate.slice(4, 6)) - 1;
            let DD = parseInt(archiveDate.slice(6, 8));
            let dObject = new Date(YYYY, MM_index, DD);
            myApp.endDate = dObject;
            let bd = getURLParameters()['bt'];
            if (bd) {
                //    do something
                let checkInt = parseInt(bd);
                if (checkInt) {
                    if (checkInt <= 20) {

                        myApp.startDate = new Date(myApp.endDate.getTime() - (checkInt * 24 * 60 * 60 * 1000));


                    } else {

                        myApp.startDate = new Date(myApp.endDate.getTime() - (7 * 24 * 60 * 60 * 1000));

                    }

                } else {
                    myApp.startDate = new Date(myApp.endDate.getTime() - (7 * 24 * 60 * 60 * 1000));
                }

            } else {
                myApp.startDate = new Date(myApp.endDate.getTime() - (7 * 24 * 60 * 60 * 1000));
            }

        }
    }
}

// myApp.startDateArchive = new Date();
// myApp.startDateArchive.setDate(myApp.startDateArchive.getDate() - 1);
// myApp.endDateArchive = new Date();

myApp.IndexColors = ['#0C6CE9', '#962422', '#1D5430', '#F76743'];


myApp.APICollection = {
    layerData: {
        Aeronet: '/apps/' + TethysAPIAppName + '/aeronetaodpm/',
        USEmbassyAOD: '/apps/' + TethysAPIAppName + '/usembassypm/',
        getGeoJSONofStations: '/apps/' + TethysAPIAppName + '/getGeoJSONofStations/',
        getGeoJsonForOneSatation: '/apps/' + TethysAPIAppName + '/getGeoJsonForOneSatation/',
        getAllStationsID: '/apps/' + TethysAPIAppName + '/getAllStationsID/',
    },
    api: {
        commonAPI: '/apps/' + TethysAPIAppName + '/getData/',
        RegionGeojson: '/apps/' + TethysAPIAppName + '/geojsonregion/',
        AOIPolygon: '/apps/' + TethysAPIAppName + '/aoipolygon/',
        GetMapImage: '/apps/' + TethysAPIAppName + '/getmapimage/',
        GetImage: '/apps/' + TethysAPIAppName + '/downloadImage/',
        SlicedFromCatalog: '/apps/' + TethysAPIAppName + '/slicedfromcatalog/'
    }
};


myApp.constants = {
    archive: {
        layerId: {
            TerraModisTrueColor: 'Archive__TerraModisTrueColor',
            VIIRS_SNPPTrueColor: 'Archive__VIIRS_SNPP-TrueColor1km',
            GEOS_PM2p5: 'Archive__GEOS_PM2p5',
            
            TerraModisAOD: 'Archive__TerraModisAOD',
            VIIRSAOD: 'Archive__VIIRSAOD',
            PM_AeronetAOD: 'Archive__aeronet',
            PM_usembassy: 'Archive__usembassy',
            O3_usembassy: 'Archive__usembassy_O3',
            O3_TROPOMI: 'Archive__TROPOMI_O3',
            O3_GEOS: 'Archive__GEOS_O3',
            SO2_TROPOMI: 'Archive__TROPOMI_SO2',
            SO2_GEOS: 'Archive__GEOS_SO2',
            NO2_TROPOMI: 'Archive__TROPOMI_NO2',
            NO2_GEOS: 'Archive__GEOS_NO2',
            CO_TROPOMI: 'Archive__TROPOMI_CO',
            CO_TROPOMI_SERVIR: 'Archive__TROPOMI_CO_SERVIR',
            CO_GEOS: 'Archive__GEOS_CO',
            NO2_AST: 'Archive__AST_NO2',
            SO2_AST: 'Archive__AST_SO2',
            BT_PM10: 'BT_PM10',
            BT_PM2p5: 'BT_PM2p5',
            BT_O3: 'BT_O3',
            BT_SO2: 'BT_SO2',
            BT_NOx: 'BT_NOx',
            BT_CO: 'BT_CO',
            BT_BC: 'BT_BC',
            AMIAOD : 'Archive__AMIAOD',
        }
    },
};
myApp.IndexColors = ['#0C6CE9', '#962422', '#1D5430', '#F76743'];
myApp.AllBindedLayersList = [];
myApp.OnlyOnce = true;

myApp.getLayer = function (id) {
    // console.log(id)
    var layer;
    for (let i = 0; i < myApp.AllBindedLayersList.length; i++) {
        // console.log(myApp.AllBindedLayersList[i].getProperties().id);
        if (id == myApp.AllBindedLayersList[i].getProperties().id) { ///popDensityLayer.getProperties().id
            layer = myApp.AllBindedLayersList[i].getLayer();
            break;
        }
    }
    return layer;
};

myApp.AeronetAODStyleFun = function (feature, resolution) {
    let name = feature.get('name');

    if (resolution > 2445.98490512564) {
        name = ''
    }
    let AeronetStyle = null;
    AeronetStyle = new Style({
        image: new RegularShape({
            fill: new Fill({color: '#D5212E'}),
            stroke: new Stroke({color: 'black', width: 1}),
            points: 3,
            radius: 10,
            rotation: 0,
            angle: 0
        }),
        text: new Text({
            font: "normal 12px Arial",
            text: name,
            fill: new Fill({color: '#aa3300'}),
            stroke: new Stroke({color: '#ffffff', width: 3}),
            offsetX: 0,
            offsetY: 15,
        })
    });
    return AeronetStyle;
};
myApp.USEmbassyPM25StyleFun = function (feature, resolution) {
    let name = feature.get('name');

    if (resolution > 2445.98490512564) {
        name = ''
    }
    let USEmbassyAODStyle = null;
    USEmbassyAODStyle = new Style({
        image: new RegularShape({
            fill: new Fill({color: '#CBCB59'}),
            stroke: new Stroke({color: 'black', width: 1}),
            points: 4,
            radius: 10,
            angle: Math.PI / 4
        }),
        text: new Text({
            font: "normal 12px Arial",
            text: name,
            fill: new Fill({color: '#aa3300'}),
            stroke: new Stroke({color: '#ffffff', width: 3}),
            offsetX: 0,
            offsetY: 15,
        })
    });
    return USEmbassyAODStyle;
};
myApp.USEmbassyO3StyleFun = function (feature, resolution) {
    let name = feature.get('name');
    if (resolution > 2445.98490512564) {
        name = ''
    }
    let USEmbassyAODStyle = null;
    USEmbassyAODStyle = new Style({
        image: new RegularShape({
            fill: new Fill({color: '#CBCB59'}),
            stroke: new Stroke({color: 'black', width: 1}),
            points: 4,
            radius: 10,
            angle: Math.PI / 4
        }),
        text: new Text({
            font: "normal 12px Arial",
            text: name,
            fill: new Fill({color: '#aa3300'}),
            stroke: new Stroke({color: '#ffffff', width: 3}),
            offsetX: 0,
            offsetY: 15,
        })
    });
    return USEmbassyAODStyle;
};


myApp.formatDate = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};

let SLDRGB = `<?xml version="1.0" encoding="ISO-8859-1"?>
<StyledLayerDescriptor version="1.1.0" xsi:schemaLocation="http://www.opengis.net/sldStyledLayerDescriptor.xsd"
                       xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc"
                       xmlns:se="http://www.opengis.net/se" xmlns:xlink="http://www.w3.org/1999/xlink"
                       xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:resc="http://www.resc.reading.ac.uk">
    <NamedLayer>
     <se:Name>red</se:Name>
        <UserStyle>
            <se:Name>Thesholded colour scheme</se:Name>
            <se:CoverageStyle>
                <se:Rule>
                    <resc:RasterRGBSymbolizer>
                        <se:Opacity>1.0</se:Opacity>
                        <se:ColorMap>
                            <resc:RedBand>
                                <resc:BandName>red</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>0</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                </resc:Range>
                            </resc:RedBand>
                            <resc:GreenBand>
                                <resc:BandName>green</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>0</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                </resc:Range>
                            </resc:GreenBand>
                            <resc:BlueBand>
                                <resc:BandName>blue</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>1</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                    <resc:Spacing>linear</resc:Spacing>
                                </resc:Range>
                            </resc:BlueBand>
                        </se:ColorMap>
                    </resc:RasterRGBSymbolizer>
                </se:Rule>
            </se:CoverageStyle>
        </UserStyle>
    </NamedLayer>
</StyledLayerDescriptor>
`;



// myApp.TrueColorImage = {
//     catalog: 'catalog/HKHAirQualityWatch/RecentAndArchive/TerraMODIS-TrueColor1km/catalog.xml',
//     useSLD: true,
//     isTimeDimensionLayer: true,
//     SLD: SLDRGB,
//     getStartDate: function () {
//         return myApp.formatDate(myApp.startDate)
//     },
//     getEndDate: function () {
//         return myApp.formatDate(myApp.endDate)
//     },
//     VisibleDivBind: true,
//     threddLayerProp: {
//         id: myApp.constants.archive.layerId.TerraModisTrueColor,
//         title: 'TerraModis-TrueColor',
//         visible: false,
//         opacity: 0.5,
//         legendPath: Action.Base + '/' + Action.trueColorLegendImage,
//         ThreddsDataServerVersion: 5,
//         serverType: 'TDS',
//         timeSeries: false,
//         alignTimeSlider: 'right',
//         timeSliderSize: 'small',
//         showlegend: false,
//         showControlPanel: true,
//         zIndex: 10,
//         filterCoodrdinate: filterCoodrdinate,
//         RGBComposite: true,
//         showAnimationButton: true,
//         animationPlot: {title_text: 'TERRA/MODIS Color Image', bbox: [60, 15, 100, 38], resolution: 400},
//         source: {
//             url: [],
//             params: {
//                 'LAYERS': 'red',
//                 'transparent': true
//             }
//         },
//         mask: DefaultMaskWMS,
//         CropOrMask: 'crop',
//         changeWMSProxy: true,
//     }
// };

// myApp.TrueColorImage = {
//     catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/VIIRS_SNPP-TrueColor1km/catalog.xml',
//     useSLD: true,
//     isTimeDimensionLayer: true,
//     SLD: SLDRGB,
//     getStartDate: function () {
//         return myApp.formatDate(myApp.startDate)
//     },
//     getEndDate: function () {
//         return myApp.formatDate(myApp.startDate)
//     },
//     VisibleDivBind: true,
//     threddLayerProp: {
//         id: myApp.constants.archive.layerId.VIIRS_SNPPTrueColor,
//         title: 'VIIRS SNPP TrueColor (' + myApp.formatDate(myApp.startDate) + ')',
//         visible: true,
//         opacity: 0.5,
//         legendPath: Action.Base + '/' + Action.trueColorLegendImage,
//         ThreddsDataServerVersion: 5,
//         serverType: 'TDS',
//         timeSeries: false,
//         alignTimeSlider: 'left',
//         timeSliderSize: 'small',
//         showlegend: false,
//         showControlPanel: true,
//         zIndex: 1,
//         source: {
//             url: [],
//             params: {
//                 'LAYERS': 'red',
//                 'transparent': true
//             }
//         },
//         mask: DefaultMaskWMS,
//         CropOrMask: 'crop',
//         changeWMSProxy: true,
//     }
// };


myApp.TrueColorImage = {
    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/VIIRS_SNPP-TrueColor1km/catalog.xml',
    useSLD: true,
    isTimeDimensionLayer: true,
    SLD: SLDRGB,
    getStartDate: function () {
        return myApp.formatDate(myApp.startDate)
    },
    getEndDate: function () {
        return myApp.formatDate(myApp.endDate)
    },
    VisibleDivBind: true,
    threddLayerProp: {
        id: myApp.constants.archive.layerId.VIIRS_SNPPTrueColor,
        title: 'VIIRS SNPP TrueColor',
        visible: false,
        opacity: 0.5,
        legendPath: Action.Base + '/' + Action.trueColorLegendImage,
        ThreddsDataServerVersion: 5,
        serverType: 'TDS',
        timeSeries: false,
        alignTimeSlider: 'right',
        timeSliderSize: 'small',
        showlegend: false,
        showControlPanel: true,
        defaultLayerStartFrom: -1,
        zIndex: 10,
        filterCoodrdinate: filterCoodrdinate,
        RGBComposite: true,
        showAnimationButton: true,
        animationPlot: {title_text: 'VIIRS True Color Image', bbox: [60, 15, 100, 38], resolution: 400},
        source: {
            url: [],
            params: {
                'LAYERS': 'red',
                'transparent': true
            }
        },
        mask: DefaultMaskWMS,
        CropOrMask: 'crop',
        changeWMSProxy: true,
    }
};

myApp.DefaultSations = {
    aeronetAOD: [10, 11, 10, 11],
    pm2p5Embassy: [6, 7, 6, 7],
    o3Embassy: [6, 7, 6, 7],
    NepalStation: [13,9]
}

myApp.cascaderObj = [
    {
        label: 'PM',
        value: 1,
        children: [
            // {
            //     label: 'Surface Observation-AOD (AERONET)',
            //     value: 11,
            //     layerId: myApp.constants.archive.layerId.PM_AeronetAOD,
            //     stationData: true,
            //     ModelClass: 'AeronetAod',
            //     ModelClassDataList: 'AeronetDataList',
            //     typeName: 'aod',
            //     defaultStation: myApp.DefaultSations.aeronetAOD,
            //     chart: {
            //         title: function (stationName, sd, ed) {
            //             return `${stationName} (${sd} - ${ed})`
            //         },
            //         subTitle: 'AERONET level 1.5 data measured at 500nm',
            //         SeriesName: 'SeriesName',
            //         YaxisLabel: 'AOD',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         },
            //         plotType: 'point'
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.archive.layerId.PM_AeronetAOD,
            //         title: 'Surface Observation-AOD (AERONET)',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 5,
            //         layer: 'AirQuality:aeronet_aod',
            //     },
            // },
            // {
            //     label: 'Ground Observation-PM2.5 (AirNow)',
            //     layerId: myApp.constants.archive.layerId.PM_usembassy,
            //     value: 12,
            //     stationData: true,
            //     ModelClass: 'UsEmbassyPm',
            //     ModelClassDataList: 'UsEmbassyDataList',
            //     typeName: 'pm',
            //     defaultStation: myApp.DefaultSations.pm2p5Embassy,
            //     chart: {
            //         title: function (stationName, sd, ed) {
            //             return `${stationName} (${sd} - ${ed})`
            //         },
            //         subTitle: 'source: AirNow',
            //         SeriesName: 'PM2.5',
            //         YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.archive.layerId.PM_usembassy,
            //         title: 'Ground Observation-PM2.5 (AirNow)',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQuality:us_embassy_pm2p5',
            //     },
            // },
            // {
            //     label: 'Ground Observation-PM1',
            //     layerId: myApp.constants.archive.layerId.BD_Gov_PM1,
            //     value: 15,
            //     stationData: true,
            //     ModelClass: 'ObservationStationsBhutan',
            //     ModelClassDataList: 'ObservationStationsBhutanDataList',
            //     typeName: 'PM1_I',
            //     defaultStation: myApp.DefaultSations.NepalStation,
            //     chart: {
            //         title: function (stationName, sd, ed) {
            //             return `${stationName} (${sd} - ${ed})`
            //         },
            //         subTitle: 'source: ICIMOD',
            //         SeriesName: 'PM1',
            //         YaxisLabel: 'PM<sub>1</sub>(μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false, plotType: 'point'
            //         id: myApp.constants.archive.layerId.BD_Gov_PM1,
            //         title: 'Ground Observation-PM1',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQualityBD:bangladesh_aq_stations',
            //     },
            // },
            {
                label: 'Ground Observation-PM2.5',
                layerId: myApp.constants.archive.layerId.BT_PM2p5,
                value: 11,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'pm2.5',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'PM2.5',
                    YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                    
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_PM2p5,
                    title: 'Ground Observation-PM2.5',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Ground Observation-PM10',
                layerId: myApp.constants.archive.layerId.BT_PM10,
                value: 12,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'pm10',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                      
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'PM10',
                    YaxisLabel: 'PM<sub>10</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_PM10,
                    title: 'Ground Observation-PM10',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            // {
            //     label: 'Ground Observation-TSP',
            //     layerId: myApp.constants.archive.layerId.Nep_Gov_tsp,
            //     value: 18,
            //     stationData: true,
            //     ModelClass: 'ObservationStationsBhutan',
            //     ModelClassDataList: 'ObservationStationsBhutanDataList',
            //     typeName: 'TSP_I',
            //     defaultStation: myApp.DefaultSations.NepalStation,
            //     chart: {
            //         title: function (stationName, sd, ed) {
            //             return `${stationName} (${sd} - ${ed})`
            //         },
            //         subTitle: 'source: AirNow',
            //         SeriesName: 'TSP',
            //         YaxisLabel: 'TSP (μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.archive.layerId.Nep_Gov_tsp,
            //         title: 'Ground Observation-TSP',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQualityBD:bangladesh_aq_stations',
            //     },
            // },

            {
                label: 'Reanalysis-PM2.5 (GEOS)',
                layerId: myApp.constants.archive.layerId.GEOS_PM2p5,
                value: 13,
                stationData: false,
                layerProperties: {
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/PM/GEOS-PM2p5/catalog.xml',
                    initilize: false,
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.GEOS_PM2p5,
                        title: 'GEOS PM2.5',
                        visible: false,
                        opacity: 0.5,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'PM2p5',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': "0,100",
                                'transparent': true
                            }
                        },
                        unit: 'µg/m<sup>3<sup>',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 11,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'GEOS $PM_{2.5}$(µg/$m^{3}$)',
                                TimeZone: ' UTC'
                            })
                        },
                        chartDetail: {
                            title: 'GEOS',
                            unit: 'PM2.5 µg/m<sup>3</sup>',
                            SeriesName: "value",
                            Product: 'PM<sub>2.5</sub>',
                            Source: 'GEOS'
                        },
                    }
                }
            },
            {
                label: 'Satellite-AOD (Terra-MODIS)',
                layerId: myApp.constants.archive.layerId.TerraModisAOD,
                value: 14,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/PM/TerraModis-AOD/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.TerraModisAOD,
                        title: 'TerraModis-AOD',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'aod_550',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0.01,1',
                                'transparent': true
                            }
                        },
                        unit: '',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 12,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'TerraModis-AOD',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'TerraModis-AOD', unit: "AOD", SeriesName: "value",
                            Product: 'AOD',
                            Source: 'Terra MODIS'
                        },
                    }
                }
            },

            {
                label: 'Satellite-AOD (VIIRS-SNPP)',
                layerId: myApp.constants.archive.layerId.VIIRSAOD,
                value: 15,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/PM/VIIRS-AOD/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.VIIRSAOD,
                        title: 'VIIRS SNPP-AOD',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'AOD550',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0.01,1',
                                'transparent': true
                            }
                        },
                        unit: '',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 12,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'VIIRS SNPP-AOD',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'VIIRS SNPP-AOD', unit: "AOD", SeriesName: "value",
                            Product: 'AOD',
                            Source: 'VIIRS SNPP'
                        },
                    }
                }
            },

            {
                label: 'Satellite-AOD (GK2A AMI)',
                layerId: myApp.constants.archive.layerId.AMIAOD,
                value: 16,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/PM/AMI-AOD/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.gk2a_endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.AMIAOD,
                        title: 'GK2A AMI AOD',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        defaultLayerStartFrom: -1,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        showAnimationButton: true,
                        animationPlot: {
                            title_text: 'Satellite-AOD (GK2A-AMI)',
                            bbox: [60, 15, 100, 38],
                            resolution: 400,
                            positionLegend: [0.85, 0.105, 0.0755, 0.78]
                        },
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'aod',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0.01,1',
                                'transparent': true
                            }
                        },
                        unit: '',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 12,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'GK2A-AMI AOD',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'GK2A AMI-AOD', unit: "AOD", SeriesName: "value",
                            Product: 'AOD',
                            Source: 'GK2A-AMI'
                        },
                    }
                }
            },
        ]
    },
    {
        label: 'O3',
        value: 2,
        children: [
            
            // {
            //     label: 'Surface Observation-O3',
            //     layerId: myApp.constants.archive.layerId.O3_usembassy,
            //     value: 23,
            //     stationData: true,
            //     ModelClass: 'UsEmbassyPm',
            //     ModelClassDataList: 'UsEmbassyDataList',
            //     typeName: 'O3',
            //     defaultStation: myApp.DefaultSations.o3Embassy,
            //     chart: {
            //         title: function (stationName, sd, ed) {
            //             return `${stationName} (${sd} - ${ed})`
            //         },
            //         subTitle: 'source: AirNow',
            //         SeriesName: 'O3',
            //         YaxisLabel: 'O<sub>3</sub>(ppb)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.archive.layerId.O3_usembassy,
            //         title: 'Surface Observation-O3',
            //         visible: true,
            //         opacity: 1,
            //         zIndex: 7,
            //         layer: 'AirQuality:us_embassy_o3',
            //     },
            // },

            {
                label: 'Ground Observation-O3',
                layerId: myApp.constants.archive.layerId.BT_O3,
                value: 21,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'o3',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'PM10',
                    YaxisLabel: 'O<sub>3</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_O3,
                    title: 'Ground Observation-O3',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Satellite-O3 (TROPOMI-GEE)',
                layerId: myApp.constants.archive.layerId.O3_TROPOMI,
                value: 22,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/O3/TROPOMI-O3/catalog.xml',
                    useSLD: false,
                    ends_with: '.nc',
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.O3_TROPOMI,
                        title: 'TROPOMI O3 (TROPOMI-GEE)',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'O3',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,1',
                                'transparent': true
                            }
                        },
                        unit: 'molecules / sq.cm',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 15,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'TROPOMI $O_{3}$($10^{17}$ molecules/$cm^{2}$)',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'TROPOMI',
                            unit: "10<sup>17</sup> molecules/cm<sup>2</sup>",
                            SeriesName: "value",
                            Product: 'O<sub>3</sub>',
                            Source: 'TROPOMI-GEE'
                        },
                    }
                }
            },

            {
                label: 'Reanalysis-O3 (GEOS)',
                layerId: myApp.constants.archive.layerId.O3_GEOS,
                value: 23,
                stationData: false,
                layerProperties: {
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/O3/GEOS-O3/catalog.xml',
                    initilize: false,
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.O3_GEOS,
                        title: 'GEOS O3',
                        visible: false,
                        opacity: 0.5,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'O3',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': "0,100",
                                'transparent': true
                            }
                        },
                        unit: 'µg/m<sup>3<sup>',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 11,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'GEOS $O{3}$(µg/$m^{3}$)',
                                TimeZone: ' UTC'
                            })
                        },
                        chartDetail: {
                            title: 'GEOS',
                            unit: 'O3 µg/m<sup>3</sup>',
                            SeriesName: "value",
                            Product: 'O<sub>3</sub>',
                            Source: 'GEOS'
                        },
                    }
                }
            },

            // {
            //     label: 'Satellite-O3 (TROPOMI-SERVIR AST)',
            //     layerId: myApp.constants.archive.layerId.O3_TROPOMI,
            //     value: 23,
            //     stationData: false,
            //     layerProperties: {
            //         initilize: false,
            //         catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/O3/AST-HKH-O3/catalog.xml',
            //         useSLD: false,
            //         isTimeDimensionLayer: true,
            //         getStartDate: function () {
            //             return myApp.formatDate(myApp.startDate)
            //         },
            //         getEndDate: function () {
            //             return myApp.formatDate(myApp.endDate)
            //         },
            //         VisibleDivBind: false,
            //         threddLayerProp: {
            //             id: myApp.constants.archive.layerId.O3_TROPOMI,
            //             title: 'AST O3',
            //             visible: false,
            //             opacity: 0.6,
            //             ThreddsDataServerVersion: 5,
            //             serverType: 'TDS',
            //             timeSeries: false,
            //             alignTimeSlider: 'right',
            //             timeSliderSize: 'small',
            //             showlegend: false,
            //             showControlPanel: true,
            //             source: {
            //                 url: [],
            //                 params: {
            //                     'LAYERS': 'vertical_column_total',
            //                     'STYLES': 'default-scalar/x-Rainbow',
            //                     'COLORSCALERANGE': '0,10',
            //                     'transparent': true
            //                 }
            //             },
            //             unit: 'ppb',
            //             mask: DefaultMaskWMS,
            //             CropOrMask: 'crop',
            //             changeWMSProxy: true,
            //             filterCoodrdinate: filterCoodrdinate,
            //             aoi: true,
            //             zIndex: 16,
            //             api: {
            //                 createGIF: myApp.APICollection.api.CreateGIFImage,
            //                 GetImage: myApp.APICollection.api.GetImage,
            //                 TimeZone: ' UTC'
            //             },
            //             plotInfo: function () {
            //                 return Object.assign(DefaultPlotInfo, {title: 'GEOS $SO_{2}$(ppb)', TimeZone: ' UTC'})
            //             },
            //             chartDetail: {
            //                 title: 'AST TROPOMI O<sub>3</sub>',
            //                 unit: "Dobson units",
            //                 SeriesName: "value",
            //                 Product: 'SO<sub>2</sub>',
            //                 Source: 'TROPOMI-SERVIR AST'
            //             },
            //         }
            //     }
            // },
        ]
    },
    {
        label: 'SO2',
        value: 3,
        children: [
            
            
            
            {
                label: 'Ground Observation-SO2',
                layerId: myApp.constants.archive.layerId.BT_SO2,
                value: 31,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'so2',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        //  return `AQI - ${stationName} (based on hourly SO<sub>2</sub> )`
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'so2',
                    YaxisLabel: 'SO<sub>2</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_SO2,
                    title: 'Ground Observation-SO2',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Satellite-SO2 (TROPOMI-GEE)',
                layerId: myApp.constants.archive.layerId.SO2_TROPOMI,
                value: 32,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/SO2/TROPOMI-SO2/catalog.xml',
                    useSLD: false,
                    ends_with: '.nc',
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.SO2_TROPOMI,
                        title: 'TROPOMI SO2 (TROPOMI-GEE)',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'SO2',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,1',
                                'transparent': true
                            }
                        },
                        unit: 'molecules / sq.cm',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 15,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'TROPOMI $SO_{2}$($10^{17}$ molecules/$cm^{2}$)',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'TROPOMI',
                            unit: "10<sup>17</sup> molecules/cm<sup>2</sup>",
                            SeriesName: "value",
                            Product: 'SO<sub>2</sub>',
                            Source: 'TROPOMI-GEE'
                        },
                    }
                }
            },
            {
                label: 'Reanalysis-SO2 (GEOS)',
                layerId: myApp.constants.archive.layerId.SO2_GEOS,
                value: 33,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/SO2/GEOS-SO2/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.SO2_GEOS,
                        title: 'GEOS SO2',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'SO2',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,10',
                                'transparent': true
                            }
                        },
                        unit: 'ppb',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 16,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {title: 'GEOS $SO_{2}$(ppb)', TimeZone: ' UTC'})
                        }, chartDetail: {
                            title: 'GEOS', unit: "ppb", SeriesName: "value",
                            Product: 'SO<sub>2</sub>',
                            Source: 'GEOS'
                        },
                    }
                }
            },
            {
                label: 'Satellite-SO2 (TROPOMI-SERVIR AST)',
                layerId: myApp.constants.archive.layerId.SO2_AST,
                value: 33,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/SO2/AST-HKH-SO2/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.SO2_AST,
                        title: 'AST SO2',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'vertical_column_total',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,10',
                                'transparent': true
                            }
                        },
                        unit: 'ppb',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 16,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {title: 'GEOS $SO_{2}$(ppb)', TimeZone: ' UTC'})
                        },
                        chartDetail: {
                            title: 'AST TROPOMI SO<sub>2</sub>',
                            unit: "Dobson units",
                            SeriesName: "value",
                            Product: 'SO<sub>2</sub>',
                            Source: 'TROPOMI-SERVIR AST'
                        },
                    }
                }
            },
        ]
    },
    {
        label: 'NOx',
        value: 4,
        children: [
            
            {
                label: 'Ground Observation-NOx',
                layerId: myApp.constants.archive.layerId.BT_NOx,
                value: 41,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'no2',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        //  return `AQI - ${stationName} (based on hourly NO<sub>2</sub> )`
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'NOx',
                    YaxisLabel: 'NO<sub>x</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
            
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_NOx,
                    title: 'Ground Observation-NOx',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Satellite-NO2 (TROPOMI-GEE)',
                layerId: myApp.constants.archive.layerId.NO2_TROPOMI,
                value: 42,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/NO2/TROPOMI-NO2/catalog.xml',
                    useSLD: false,
                    ends_with: '.nc',
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate)
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate)
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.NO2_TROPOMI,
                        title: 'TROPOMI NO2 (GEE)',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'NO2',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,10',
                                'transparent': true
                            }
                        },
                        unit: 'molecules / sq.cm',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 17,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'TROPOMI $NO_{2}$($10^{15}$ molecules/$cm^{2}$)',
                                TimeZone: ' UTC'
                            })
                        },
                        chartDetail: {
                            title: 'TROPOMI',
                            unit: "10<sup>15</sup> molecules/cm<sup>2</sup>",
                            SeriesName: "value",
                            Product: 'NO<sub>2</sub>',
                            Source: 'TROPOMI-GEE'
                        },
                    }
                }
            },
            {
                label: 'Reanalysis-NO2 (GEOS)',
                layerId: myApp.constants.archive.layerId.NO2_GEOS,
                value: 43,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/NO2/GEOS-NO2/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate);
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate);
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.NO2_GEOS,
                        title: 'GEOS NO2',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'NO2',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,10',
                                'transparent': true
                            }
                        },
                        unit: 'ppb',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 18,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {title: 'GEOS $NO_{2}$(ppb)', TimeZone: ' UTC'})
                        }, chartDetail: {
                            title: 'GEOS', unit: "ppb", SeriesName: "value",
                            Product: 'NO<sub>2</sub>',
                            Source: 'GEOS'
                        },
                    }
                }
            },

            // {
            //     label: 'Satellite-NO2 (TROPOMI-SERVIR AST)',
            //     layerId: myApp.constants.archive.layerId.NO2_AST,
            //     value: 43,
            //     stationData: false,
            //     layerProperties: {
            //         initilize: false,
            //         catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/NO2/AST-HKH-NO2/catalog.xml',
            //         useSLD: false,
            //         isTimeDimensionLayer: true,
            //         getStartDate: function () {
            //             return myApp.formatDate(myApp.startDate);
            //         },
            //         getEndDate: function () {
            //             return myApp.formatDate(myApp.endDate);
            //         },
            //         VisibleDivBind: false,
            //         threddLayerProp: {
            //             id: myApp.constants.archive.layerId.NO2_AST,
            //             title: 'AST TROPOMI NO2',
            //             visible: false,
            //             opacity: 0.6,
            //             ThreddsDataServerVersion: 5,
            //             serverType: 'TDS',
            //             timeSeries: false,
            //             alignTimeSlider: 'right',
            //             timeSliderSize: 'small',
            //             showlegend: false,
            //             showControlPanel: true,
            //             source: {
            //                 url: [],
            //                 params: {
            //                     'LAYERS': 'vertical_column_troposphere',
            //                     'STYLES': 'default-scalar/x-Rainbow',
            //                     'COLORSCALERANGE': '0,10',
            //                     'transparent': true
            //                 }
            //             },
            //             unit: 'ppb',
            //             mask: DefaultMaskWMS,
            //             CropOrMask: 'crop',
            //             changeWMSProxy: true,
            //             filterCoodrdinate: filterCoodrdinate,
            //             aoi: true,
            //             zIndex: 18,
            //             api: {
            //                 createGIF: myApp.APICollection.api.CreateGIFImage,
            //                 GetImage: myApp.APICollection.api.GetImage,
            //                 TimeZone: ' UTC'
            //             },
            //             plotInfo: function () {
            //                 return Object.assign(DefaultPlotInfo, {title: 'GEOS $NO_{2}$(ppb)', TimeZone: ' UTC'})
            //             },
            //             chartDetail: {
            //                 title: 'AST TROPOMI NO<sup>2</sup>',
            //                 unit: "10<sup>15</sup> molecules/cm<sup>2</sup>",
            //                 SeriesName: "value",
            //                 Product: 'NO<sub>2</sub>',
            //                 Source: 'TROPOMI-SERVIR AST'
            //             },
            //         }
            //     }
            // },
        ],
    },
    {
        label: 'CO',
        value: 5,
        children: [
            
            
           
            {
                label: 'Ground Observation-CO',
                layerId: myApp.constants.archive.layerId.BT_CO,
                value: 51,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'co',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        //  return `AQI - ${stationName} (based on hourly CO )`
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'co',
                    YaxisLabel: 'CO(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_CO,
                    title: 'Ground Observation-CO',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Satellite-CO (TROPOMI-GEE)',
                layerId: myApp.constants.archive.layerId.CO_TROPOMI,
                value: 52,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/CO/TROPOMI-CO/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate);
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate);
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.CO_TROPOMI,
                        title: 'TROPOMI CO',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'CO',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '1,4',
                                'transparent': true
                            }
                        },
                        unit: 'molecules / sq.cm',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 19,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {
                                title: 'TROPOMI CO($10^{18}$ molecules/$cm^{2}$)',
                                TimeZone: ' UTC'
                            })
                        }, chartDetail: {
                            title: 'TROPOMI',
                            unit: "10<sup>18</sup> molecules/cm<sup>2</sup>",
                            SeriesName: "value",
                            Product: 'CO',
                            Source: 'TROPOMI-GEE'
                        },
                    }
                }
            },
            {
                label: 'Reanalysis-CO (GEOS)',
                layerId: myApp.constants.archive.layerId.CO_GEOS,
                value: 53,
                stationData: false,
                layerProperties: {
                    initilize: false,
                    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/CO/GEOS-CO/catalog.xml',
                    useSLD: false,
                    isTimeDimensionLayer: true,
                    getStartDate: function () {
                        return myApp.formatDate(myApp.startDate);
                    },
                    getEndDate: function () {
                        return myApp.formatDate(myApp.endDate);
                    },
                    VisibleDivBind: false,
                    threddLayerProp: {
                        id: myApp.constants.archive.layerId.CO_GEOS,
                        title: 'GEOS CO',
                        visible: false,
                        opacity: 0.6,
                        ThreddsDataServerVersion: 5,
                        serverType: 'TDS',
                        timeSeries: false,
                        alignTimeSlider: 'right',
                        timeSliderSize: 'small',
                        showlegend: false,
                        showControlPanel: true,
                        source: {
                            url: [],
                            params: {
                                'LAYERS': 'CO',
                                'STYLES': 'default-scalar/x-Rainbow',
                                'COLORSCALERANGE': '0,500',
                                'transparent': true
                            }
                        },
                        unit: 'ppb',
                        mask: DefaultMaskWMS,
                        CropOrMask: 'crop',
                        changeWMSProxy: true,
                        filterCoodrdinate: filterCoodrdinate,
                        aoi: true,
                        zIndex: 20,
                        api: {
                            createGIF: myApp.APICollection.api.CreateGIFImage,
                            GetImage: myApp.APICollection.api.GetImage,
                            TimeZone: ' UTC'
                        },
                        plotInfo: function () {
                            return Object.assign(DefaultPlotInfo, {title: 'GEOS CO(ppb)'})
                        }, chartDetail: {
                            title: 'GEOS', unit: "CO (ppb)", SeriesName: "value",
                            Product: 'CO',
                            Source: 'GEOS'
                        },
                    }
                }
            },

            // {
            //     label: 'Satellite-CO (TROPOMI-SERVIR AST)',
            //     layerId: myApp.constants.archive.layerId.CO_TROPOMI_SERVIR,
            //     value: 53,
            //     stationData: false,
            //     layerProperties: {
            //         initilize: false,
            //         catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/CO/AST-HKH-CO/catalog.xml',
            //         useSLD: false,
            //         isTimeDimensionLayer: true,
            //         getStartDate: function () {
            //             return myApp.formatDate(myApp.startDate);
            //         },
            //         getEndDate: function () {
            //             return myApp.formatDate(myApp.endDate);
            //         },
            //         VisibleDivBind: false,
            //         threddLayerProp: {
            //             id: myApp.constants.archive.layerId.CO_TROPOMI_SERVIR,
            //             title: 'TROPOMI CO (SERVIR AST)',
            //             visible: false,
            //             opacity: 0.6,
            //             ThreddsDataServerVersion: 5,
            //             serverType: 'TDS',
            //             timeSeries: false,
            //             alignTimeSlider: 'right',
            //             timeSliderSize: 'small',
            //             showlegend: false,
            //             showControlPanel: true,
            //             source: {
            //                 url: [],
            //                 params: {
            //                     'LAYERS': 'vertical_column_total',
            //                     'STYLES': 'default-scalar/x-Rainbow',
            //                     'COLORSCALERANGE': '1,4',
            //                     'transparent': true
            //                 }
            //             },
            //             unit: 'molecules / sq.cm',
            //             mask: DefaultMaskWMS,
            //             CropOrMask: 'crop',
            //             changeWMSProxy: true,
            //             filterCoodrdinate: filterCoodrdinate,
            //             aoi: true,
            //             zIndex: 19,
            //             api: {
            //                 createGIF: myApp.APICollection.api.CreateGIFImage,
            //                 GetImage: myApp.APICollection.api.GetImage,
            //                 TimeZone: ' UTC'
            //             },
            //             plotInfo: function () {
            //                 return Object.assign(DefaultPlotInfo, {
            //                     title: 'TROPOMI CO($10^{18}$ molecules/$cm^{2}$)',
            //                     TimeZone: ' UTC'
            //                 })
            //             }, chartDetail: {
            //                 title: 'TROPOMI-SERVIR AST',
            //                 unit: "10<sup>18</sup> molecules/cm<sup>2</sup>",
            //                 SeriesName: "value",
            //                 Product: 'CO',
            //                 Source: 'TROPOMI-SERVIR AST'
            //             },
            //         }
            //     }
            // },

        ]
    },


    {
        label: 'BC',
        value: 6,
        children: [
            {
                label: 'Ground Observation-BC',
                layerId: myApp.constants.archive.layerId.BT_BC,
                value: 61,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'bc6',
                defaultStation: myApp.DefaultSations.NepalStation,
                
                chart: {
                    title: function (stationName) {
                        return `${stationName} (${sd} - ${ed})`
                        //  return `AQI - ${stationName} (based on hourly CO )`
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'BC',
                    YaxisLabel: 'BC(μg/m<sup>3</sup>)',   
                    XaxisLabel: function () {
                        return 'Time (UTC)'

                    }
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.archive.layerId.BT_BC,
                    title: 'Ground Observation-BC',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
        ]

    }

];


myApp.formatDate = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};

myApp.makeRequest = function (method, url) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send();
    });
};


myApp.getForecastWMSList = async function (url) {
    let result = await myApp.makeRequest("GET", url);
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(result, "text/xml");
    let wmsList = [];
    let interestedDate = myApp.formatDate(myApp.forecastDate).replace(/-/g, '');
    let DimensionTag = xmlDoc.getElementsByTagName("catalogRef");
    let DateHavingCatalog = null;
    for (let kk of DimensionTag) {
        if (interestedDate == kk.getAttribute('xlink:title')) {
            DateHavingCatalog = url.replace('catalog.xml', kk.getAttribute('xlink:href'));
            break;
        }
    }
    if (DateHavingCatalog) {
        let result1 = await this.makeRequest("GET", DateHavingCatalog);
        let parser1 = new DOMParser();
        let xmlDoc1 = parser1.parseFromString(result1, "text/xml");
        let dataset = xmlDoc1.getElementsByTagName("dataset");
        for (let jj of dataset) {
            let name = jj.getAttribute('name');
            if (name.slice(-3) == '.nc') {
                wmsList.push(DateHavingCatalog.replace('/catalog/', '/wms/').replace('catalog.xml', name));
            }
        }
    }
    return wmsList.sort()
};

myApp.datetimePointChartObj = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {
    let data = {
            chart: {
                marginLeft: 65,
                /* marginRight: 0, */
                /* spacingLeft: 0, */
                /* spacingRight: 0 */
                backgroundColor: 'transparent',
                plotBorderColor: '#afafaf',
                plotBorderWidth: 1,
            },
            title: {
                text: title,
                fontSize: '10px',
                useHTML: true
            },
            subtitle: {
                text: subTitle,
                fontSize: '8px'
            },
            series: [{
                name: SeriesName,
                data: SeriesData,
                lineWidth: 0,
                marker: {
                    enabled: true,
                    symbol: 'diamond',
                    radius: 2
                },
            }],
            xAxis: {
                type: 'datetime',
                title: {
                    text: XaxisLabel,
                    align: 'high',
                },
                tickLength: 0,
                lineColor: 0,
                lineWidth: 0
            },
            yAxis: {
                title: {
                    text: `<span style="display:inline-block; -webkit-transform: rotate(270deg); -moz-transform: rotate(270deg); -ms-transform: rotate(270deg); -o-transform: rotate(270deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
                    useHTML: true,
                    rotation: 0,
                    // align: 'high',
                    offset: 0,
                    x: -50
                },
                tickLength: 0,
                lineColor: 0,
                lineWidth: 0,
                gridLineWidth: 0
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    color: plotColor
                }
            },
            lang: {
                noData: DataPeriod + 'data not available for this station.'
            },
            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadPDF",
                            "downloadSVG",
                            "separator",
                            "downloadCSV",
                            "downloadXLS",
                            //"viewData",
                            "openInCloud"]
                    }
                },
                // chartOptions: {
                //     title: {
                //         text: title,
                //         fontSize: '10px',
                //         useHTML: true
                //     }, yAxis: {
                //         title: {
                //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
                //             useHTML: true,
                //             rotation: 250
                //         }
                //     },
                // },
                allowHTML: true,
                // fallbackToExportServer: false,
                // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
            }
        }
    ;
    return data;
};

myApp.AQIBarChartObject = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {

    let seriesDataProcess = [{
        name: 'Good (0-50)',
        data: [],
        color: '#00e400'
    }, {
        name: 'Moderate (51-100)',
        data: [],
        color: '#ffff00'
    }, {
        name: 'Unhealthy for Sensitive Groups (101-150)',
        data: [],
        color: '#ff7e00'
    }, {
        name: 'Unhealthy (151-200)',
        data: [],
        color: '#ff0000'
    }, {
        name: 'Very Unhealthy (201-300)',
        data: [],
        color: '#8f3f97'
    }, {
        name: 'Hazardous (301-500)',
        data: [],
        color: '#7e0023'
    }];

    // 0	GOOD
    // 1	MODERATE
    // 2	CAUTION
    // 3	UNHEALTHY
    // 4	VERY UNHEALTHY
    // 5	EXTREMELY UNHEALTHY

    for (let kl of SeriesData) {
        if (kl[1] > 0 && kl[1] <= 50) {
            seriesDataProcess[0].data.push(kl)
        } else if (kl[1] >= 51 && kl[1] <= 100) {
            seriesDataProcess[1].data.push(kl)
        } else if (kl[1] >= 101 && kl[1] <= 150) {
            seriesDataProcess[2].data.push(kl)
        } else if (kl[1] >= 151 && kl[1] <= 200) {
            seriesDataProcess[3].data.push(kl)
        } else if (kl[1] >= 201 && kl[1] <= 300) {
            seriesDataProcess[4].data.push(kl)
        } else if (kl[1] >= 301) {
            seriesDataProcess[5].data.push(kl)
        }
    }

    seriesDataProcess.reverse()

    let data = {
        chart: {
            type: 'column',
            plotBorderWidth: 1,
        },
        title: {
            text: title,
            fontSize: '10px',
            useHTML: true
        },
        subtitle: {
            text: subTitle,
            fontSize: '8px'
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: 'Date'
            }
        },
        lang: {
            noData: DataPeriod + 'data not available for this station.'
        },
        yAxis: {
            min: 0,
            title: {
                text: 'AQI'
            }
        },
        legend: {
            reversed: true
        },
        plotOptions: {
            series: {
                stacking: 'normal'
            }
        },
        credits: {
            enabled: false
        },
        series: seriesDataProcess,
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
                }
            },
            // chartOptions: {
            //     title: {
            //         text: title,
            //         fontSize: '10px',
            //         useHTML: true
            //     }, yAxis: {
            //         title: {
            //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
            //             useHTML: true,
            //             rotation: 250
            //         }
            //     },
            // },
            allowHTML: true,
            // fallbackToExportServer: false,
            // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
        }
    };

    return data

};

myApp.datetimeChartObj = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {
    let data = {
        chart: {
            marginLeft: 65,
            /* marginRight: 0, */
            /* spacingLeft: 0, */
            /* spacingRight: 0 */
            backgroundColor: 'transparent',
            plotBorderColor: '#afafaf',
            plotBorderWidth: 1,
        },
        title: {
            text: title,
            fontSize: '10px',
            useHTML: true
        },
        subtitle: {
            text: subTitle,
            fontSize: '8px'
        },
        series: [{
            name: SeriesName,
            data: SeriesData,
            // marker: {
            //     enabled: true,
            //     symbol: 'diamond',
            //     radius: 3
            // },
        }],
        xAxis: {
            type: 'datetime',
            title: {
                text: XaxisLabel,
                align: 'high',
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0
        },
        lang: {
            noData: DataPeriod + 'data not available for this station.'
        },
        yAxis: {
            title: {
                text: `<span style="display:inline-block; -webkit-transform: rotate(270deg); -moz-transform: rotate(270deg); -ms-transform: rotate(270deg); -o-transform: rotate(270deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
                useHTML: true,
                rotation: 0,
                // align: 'high',
                offset: 0,
                x: -50
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0,
            gridLineWidth: 0
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                color: plotColor
            }
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
                }
            },
            // chartOptions: {
            //     title: {
            //         text: title,
            //         fontSize: '10px',
            //         useHTML: true
            //     }, yAxis: {
            //         title: {
            //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
            //             useHTML: true,
            //             rotation: 250
            //         }
            //     },
            // },
            allowHTML: true,
            // fallbackToExportServer: false,
            // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
        }
    };
    return data
};

myApp.forceDownload = function (url, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
}

// myApp.datetimeChartObj = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor) {
//     let data = {
//             chart: {
//                 marginLeft: 65,
//                 /* marginRight: 0, */
//                 /* spacingLeft: 0, */
//                 /* spacingRight: 0 */
//                 backgroundColor: 'transparent',
//                 plotBorderColor: '#afafaf',
//                 plotBorderWidth: 1,
//             },
//             title: {
//                 text: title,
//                 fontSize: '10px',
//                 useHTML: true
//             },
//             subtitle: {
//                 text: subTitle,
//                 fontSize: '8px'
//             },
//             series: [{
//                 name: SeriesName,
//                 data: SeriesData,
//                 // marker: {
//                 //     enabled: true,
//                 //     symbol: 'diamond',
//                 //     radius: 3
//                 // },
//             }],
//             xAxis: {
//                 type: 'datetime',
//                 title: {
//                     text: XaxisLabel,
//                     align: 'high',
//                 },
//                 tickLength: 0,
//                 lineColor: 0,
//                 lineWidth: 0
//             },
//             yAxis: {
//                 title: {
//                     text: `<span style="display:inline-block; -webkit-transform: rotate(270deg); -moz-transform: rotate(270deg); -ms-transform: rotate(270deg); -o-transform: rotate(270deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
//                     useHTML: true,
//                     rotation: 0,
//                     // align: 'high',
//                     offset: 0,
//                     x: -50
//                 },
//                 tickLength: 0,
//                 lineColor: 0,
//                 lineWidth: 0,
//                 gridLineWidth: 0
//             },
//             legend: {
//                 enabled: false
//             },
//             credits: {
//                 enabled: false
//             },
//             plotOptions: {
//                 series: {
//                     color: plotColor
//                 }
//             },
//             exporting: {
//                 buttons: {
//                     contextButton: {
//                         menuItems: ["printChart",
//                             "separator",
//                             "downloadPNG",
//                             "downloadJPEG",
//                             "downloadPDF",
//                             "downloadSVG",
//                             "separator",
//                             "downloadCSV",
//                             "downloadXLS",
//                             //"viewData",
//                             "openInCloud"]
//                     }
//                 },
//                 // chartOptions: {
//                 //     title: {
//                 //         text: title,
//                 //         fontSize: '10px',
//                 //         useHTML: true
//                 //     }, yAxis: {
//                 //         title: {
//                 //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
//                 //             useHTML: true,
//                 //             rotation: 250
//                 //         }
//                 //     },
//                 // },
//                 allowHTML: true,
//                 // fallbackToExportServer: false,
//                 // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
//             }
//         }
//     ;
//     console.log(JSON.stringify(data));
//     return data
// };


export var AirPollutionWatchApp = myApp;